import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";
import { computeDelta } from "@/lib/format";

export function KpiCard({
  testid, label, value, icon: Icon, accent = "blue", onClick,
  cur, prev, showDelta = true, higherIsBetter = true, footer, flag,
}) {
  const accents = {
    blue: "text-blue-600 bg-blue-50",
    emerald: "text-emerald-600 bg-emerald-50",
    amber: "text-amber-600 bg-amber-50",
    red: "text-rose-600 bg-rose-50",
    slate: "text-slate-600 bg-slate-100",
    violet: "text-violet-600 bg-violet-50",
  };
  const d = showDelta ? computeDelta(cur, prev, higherIsBetter) : null;
  const deltaColor = d?.good === "good" ? "text-emerald-600" : d?.good === "bad" ? "text-rose-600" : "text-slate-400";
  const DeltaIcon = d?.dir === "up" ? ArrowUpRight : d?.dir === "down" ? ArrowDownRight : Minus;

  return (
    <motion.button
      type="button"
      data-testid={testid}
      onClick={onClick}
      whileHover={{ y: -3 }}
      transition={{ type: "spring", stiffness: 300, damping: 22 }}
      className="text-left w-full bg-white rounded-xl border border-slate-200 p-4 sm:p-5 hover:border-slate-300 hover:shadow-[0_8px_30px_rgba(15,23,42,0.06)] transition-shadow group focus:outline-none focus:ring-2 focus:ring-blue-500/40"
    >
      <div className="flex items-start justify-between">
        <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</span>
        {Icon && (
          <span className={`h-8 w-8 rounded-lg grid place-items-center ${accents[accent]}`}>
            <Icon className="h-4 w-4" />
          </span>
        )}
      </div>
      <div className="mt-3 flex items-end gap-2">
        <span className="text-2xl sm:text-[28px] leading-none font-extrabold tracking-tight tabular-nums text-slate-900 font-heading">
          {value}
        </span>
        {flag && (
          <span className={`mb-0.5 text-[10px] font-bold uppercase px-1.5 py-0.5 rounded ${flag === "Actual" ? "bg-emerald-50 text-emerald-600" : "bg-amber-50 text-amber-600"}`}>
            {flag}
          </span>
        )}
      </div>
      <div className="mt-2 min-h-[18px] flex items-center gap-1.5">
        {showDelta && d ? (
          <>
            <span className={`inline-flex items-center gap-0.5 text-xs font-semibold ${deltaColor}`}>
              <DeltaIcon className="h-3.5 w-3.5" />
              {d.pct.toFixed(1)}%
            </span>
            <span className="text-[11px] text-slate-400">vs prev</span>
          </>
        ) : (footer && <span className="text-[11px] text-slate-400">{footer}</span>)}
      </div>
      {showDelta && footer && <div className="text-[11px] text-slate-400 mt-0.5 truncate">{footer}</div>}
    </motion.button>
  );
}
